import React from "react";
import FormElement from "../../types/forms/FormElement";

type TextAreaProps = {
    textAreaId: string;
    labelText: string | undefined;
    onChange: (updatedValue: string) => void;
    value: string;
    errorMessage: string | undefined;
    containerClassName?: string;
    placeHolder?: string;
    readOnly: boolean;
    boldLabel?: boolean;
    rows?: number;
};

function TextArea({
    labelText,
    onChange,
    value,
    errorMessage,
    placeHolder,
    containerClassName,
    textAreaId,
    readOnly,
    boldLabel = true,
    rows = 3
}: TextAreaProps) {
    const errorMessageId = `${textAreaId}__error-message`;
    const inputClassName = `form-control ${readOnly ? "read-only-input" : ""}`;

    return (
        <div className={`form-group ${containerClassName}`}>
            <label className={`form-label ${boldLabel ? "fw-bold" : ""}`} htmlFor={textAreaId}>
                {labelText}
            </label>
            <textarea
                className={inputClassName}
                rows={rows}
                value={value ?? ""}
                onChange={(e) => onChange(e.target.value)}
                readOnly={readOnly}
                placeholder={placeHolder}
                aria-errormessage={errorMessageId}
            ></textarea>
            <span id={errorMessageId} className="text-danger">
                {errorMessage}
            </span>
        </div>
    );
}

export default TextArea;
